import React from 'react';

const RefreshIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-refresh" />
    </div>
  );
};

export default RefreshIcon;
